import React from 'react';
import PropTypes from 'prop-types';

const spreadAttendees = (attendees) => {
  const result = [];

  if (attendees.consultant) {
    result.push(`${attendees.consultant} (Consultant)`);
  }

  // the following can be done with a .push(...invitees)
  attendees.invitees.forEach((i) => result.push(i));

  if (attendees.requester) {
    result.push(`${attendees.requester} (Organizer)`);
  }

  return result;
};

function InterviewAttendees({ attendees, horizontal = false, consultantView = false }) {
  // attendees comes to us as a hash
  const attendeesList = spreadAttendees(attendees);

  if (consultantView) {
    return (
      <div className="interview-attendees-container muted-gray-text">
        <div className="interview-attendees-label body-text-2 mb-4">
          <span><i className="fas fa-users me-3" /></span>
          {attendeesList.length}
          {' '}
          guests
        </div>
      </div>
    );
  }

  if (horizontal) {
    const attendeesStr = attendeesList.join(', ');
    return (
      <div className="interview-attendees-container muted-gray-text">
        <div className="interview-attendees-label body-text-2 mb-4">
          <span><i className="fas fa-users me-3" /></span>
          {attendeesList.length}
          {' '}
          guests:
          {attendeesStr}
        </div>
      </div>
    );
  }

  return (
    <div className="interview-attendees-container muted-gray-text">
      <div className="interview-attendees-label body-text-2 mb-4">
        <span><i className="fas fa-users me-2" /></span>
        {attendeesList.length}
        {' '}
        guests:
      </div>
      <div className="interview-attendees-list ms-4">
        {attendeesList.map((attendee) => (
          <div
            className="body-text-2 mb-3"
            key={attendee}
          >
            {attendee}
          </div>
        ))}
      </div>
    </div>
  );
}

InterviewAttendees.propTypes = {
  attendees: PropTypes.shape({
    consultant: PropTypes.string,
    invitees: PropTypes.arrayOf(PropTypes.string),
    requester: PropTypes.string,
  }).isRequired,
  horizontal: PropTypes.bool,
  consultantView: PropTypes.bool,
};

InterviewAttendees.defaultProps = {
  horizontal: false,
  consultantView: false,
};

export default InterviewAttendees;
